module.exports = __webpack_public_path__ + "static/media/circle-up.412c260d.svg";